import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBXApfJOeKY10-3xGBFFZkuN_LbO6VeiT8",
  authDomain: "doxprofile.firebaseapp.com",
  projectId: "doxprofile",
  storageBucket: "doxprofile.appspot.com",
  messagingSenderId: "36201695369",
  appId: "1:36201695369:web:22c503e32efc4ca53f9e58",
};
// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth();
export const storage = getStorage();
export const db = getFirestore();
